module.exports = __webpack_public_path__ + "img/firstNameEle.f1132976.svg";